import {mixins} from "../app/mixin";

mixins.push({
    el: '.benefitsSelector',
    data() {
        return {
            activeStep: 1,
        }
    },
    methods: {
        setActiveStep(step) {
            if (step !== this.activeStep) {
                this.activeStep = step
            }
        },
        prevStep() {
            if (this.activeStep !== 1) {
                this.activeStep -= 1
            }
        },
        nextStep() {
            if (this.activeStep !== 3) {
                this.activeStep += 1
            }
        },
    },
});